import { useState, useEffect, useRef, useMemo } from "react"
import { useNavigate, useLocation } from "react-router-dom"
import { toast } from 'react-toastify'
import { months_list } from "../../Shared/List";
import Server from "../../Shared/Server";
import Spinner from '../../Shared/Spinner';
import {AgGridReact} from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';

const LocationMonthlyPaymentDetail = () => {
    const [data, setData] = useState([]);
    const [title, setTitle] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const gridRef = useRef();

    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {

        if (location.state) {
            const { payload } = location.state
            fetchData({public_id: payload.public_id, year: payload.year, month: payload.month});

            const monthName = months_list[payload.month - 1]?.name || ""
            setTitle(`${monthName}, ${payload.year} Payment Details`)
        }
    }, [location.state]);

    const fetchData = async (payload) => {
        setIsLoading(true)
        try {
            const response = await Server.get(`/locations/monthly/payment/detail?public_id=${payload.public_id}&year=${payload.year}&month=${payload.month}`)
            setData(response?.data);
            setIsLoading(false);
        } catch (error) {
            setIsLoading(false)
            if(error?.response?.status === 401){
                localStorage.removeItem('user')
                navigate('/login')
            }else if (error?.response?.status === 403){
                toast.error(error.response.data.detail);
                navigate('/');
            }else {
                toast.error(error?.response?.data?.detail || 'Failed to fetch payment details')
            }
        }
    }

    const defaultColDef = useMemo(() => {
        return {
            filterParams: {
                buttons: []
            }
        };
    }, []);

    const columnDefs = useMemo(() => [
        {
            headerName: "#",
            filter: false,
            maxWidth: 70,
            sortable: true,
            valueFormatter: function (params) {
            if (isNaN(params.node.id)) {
                return "";
            }
            return `${Number(params.node.rowIndex) + 1}`;
            },
        },
        {
            headerName: "Date",
            field: "date",
            sortable: true,
            filter: true,
        },
        {
            headerName: "Book",
            field: "book",
            sortable: true,
            filter: true,
        },
        {
            headerName: "Page",
            field: "page",
            sortable: true,
            filter: true,
        },
        {
            headerName: "UserName",
            field: "username",
            sortable: true,
            filter: true,
        },
        {
            headerName: "Due",
            field: "due",
            sortable: true,
            filter: true,
        },
        {
            headerName: "Paid",
            field: "paid",
            sortable: true,
            filter: true,
        },
        {
            headerName: "Discount",
            field: "discount",
            sortable: true,
            filter: true,
        },
    ], []);

    if(isLoading){
        return <Spinner/>
    }

  return (
    <>
        <div className="card">
            <div className="card-header p-2 bg-info text-white d-flex justify-content-center">
                <h3 className="card-title">{title}</h3>
            </div>
            <div className="card-body">
                <div className="row">
                    <div className="col-md-12">
                        <div className="ag-theme-alpine responsive-aggrid" style={{ height: 400, width: '100%' }}>
                        <AgGridReact
                            suppressMenuHide={true}
                            defaultColDef={defaultColDef}
                            rowData={data}
                            domLayout={"normal"}
                            rowSelection={"multiple"}
                            animateRows={true}
                            pagination={false}
                            resizable={true}
                            enableCellTextSelection={true}
                            suppressCellFocus={true}
                            ref={gridRef}
                            groupIncludeTotalFooter={false}
                            groupIncludeFooter={false}
                            columnDefs={columnDefs}
                        ></AgGridReact>{" "}
                    </div>
                    </div>
                </div>
        </div>
        </div>
      <br/>
    </>
  )
}

export default LocationMonthlyPaymentDetail